import slugifyTitle from 'Pods/ThreeDStudio/Shared/Utils/slugifyTitle'

// Builds the run detail URL /ai-3d-model-generator/3d-models/<slug>. Prefers the
// persisted `slug`; falls back to the `<slugified-title>-<id>` shape for runs
// without one. Returns '/ai' when nothing identifies a run.
export const buildSharedRunPathname = ({ id, slug, title } = {}) => {
  if (slug) {
    return `/ai-3d-model-generator/3d-models/${slug}`
  }
  if (id == null) {
    return '/ai'
  }
  return `/ai-3d-model-generator/3d-models/${slugifyTitle(title)}-${id}`
}

export default buildSharedRunPathname
